import { useCallback, useState } from "react";

interface UseSelectionModeOptions<T> {
	getKey: (item: T) => string;
}

export function useSelectionMode<T>({ getKey }: UseSelectionModeOptions<T>) {
	const [isSelectMode, setIsSelectMode] = useState(false);
	const [selectedItems, setSelectedItems] = useState<T[]>([]);

	const toggleSelection = useCallback(
		(item: T) => {
			setSelectedItems((prev) => {
				const key = getKey(item);
				const exists = prev.find((i) => getKey(i) === key);
				if (exists) {
					return prev.filter((i) => getKey(i) !== key);
				}
				return [...prev, item];
			});
		},
		[getKey],
	);

	const isSelected = useCallback(
		(item: T) => {
			const key = getKey(item);
			return selectedItems.some((i) => getKey(i) === key);
		},
		[selectedItems, getKey],
	);

	const exitSelectMode = useCallback(() => {
		setIsSelectMode(false);
		setSelectedItems([]);
	}, []);

	const enterSelectMode = useCallback(() => {
		setIsSelectMode(true);
	}, []);

	return {
		isSelectMode,
		selectedItems,
		selectedCount: selectedItems.length,
		toggleSelection,
		isSelected,
		exitSelectMode,
		enterSelectMode,
	};
}
